<template>
    <table class="w-full">
        <tr>
            <th class="font-josefin uppercase text-left px-4 pb-4">Item</th>
            <th class="font-josefin uppercase text-right px-4 pb-4">Price</th>
            <th class="font-josefin uppercase text-center px-4 pb-4">Quantity</th>
            <th class="font-josefin uppercase text-right px-4 pb-4">Subtotal</th>
        </tr>
        <tr v-for="item in items">
            <td class="text-left px-4 py-4 align-top">
                <div class="flex items-start">
                    <div class="w-full md:w-28 bg-gray-100 square-box relative overflow-hidden mr-4">
                        <picture>

                            <img class="object-cover h-full w-full absolute transform group-hover:scale-110 transition-transform ease-in-out duration-500 rounded-md"
                                 :src="`/storage/${item.event.primary_image.path}`"
                            >
                        </picture>
                    </div>

                    <div>
                        <div class="font-semibold uppercase mb-1 -mt-1">
                            {{ item.event.name }}
                        </div>
                        <div class="text-gray-500 text-sm font-medium leading-5">
                            <div>Date: {{ item.date.start_date_no_time }}</div>
                            <div>Seats: {{ item.quantity }}</div>
                            <div v-for="addOn in item.addOns">
                                {{ addOn.addOn.name }}: {{ addOn.addOnOption.name }} x {{ addOn.quantity }}
                            </div>
                        </div>
                    </div>
                </div>
            </td>
            <td class="text-right px-4 py-4 align-top">£{{ item.formatted_total }}</td>
            <td class="text-center px-4 py-4 align-top">
                <div>1</div>
            </td>
            <td class="text-right px-4 py-4 align-top">£{{ item.formatted_total }}</td>
        </tr>
        <tr v-if="membershipDiscount > 0">
            <td class="text-right px-4 py-4 align-top border-t border-gray-100" colspan="3">
                Membership Discount
            </td>
            <td class="text-right px-4 py-4 align-top border-t border-gray-100">- £{{ membershipDiscount }}</td>
        </tr>
        <tr>
            <td class="text-right px-4 py-4 align-top border-t border-gray-100 font-semibold" colspan="3">
                Total
            </td>
            <td class="text-right px-4 py-4 align-top border-t border-gray-100">£{{ total }}</td>
        </tr>
    </table>
</template>

<script>
	export default {
		props: {
		    items: {
		        type: Array,
                required: true,
            },

		    total: {
		        type: String,
                required: true,
            },

            membershipDiscount: {
		        type: Number,
                required: true,
            }
        },
	}
</script>
